/**
 * Supabase Client Configuration
 *
 * Creates the Supabase client synchronously so all consumers can import it
 * without async/await. The client is used ONLY for Realtime subscriptions.
 *
 * Auth flow:
 * 1. Client created with anon key (from env vars or backend config)
 * 2. AuthContext calls POST /api/auth/realtime-token (authenticated)
 * 3. AuthContext calls supabase.realtime.setAuth(accessToken)
 * 4. Realtime channels then have user-level RLS access
 */

import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL!;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false,
    debug: false,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
  global: {
    headers: {
      'X-Client-Info': 'trade-loop-web',
    },
  },
});

export type { SupabaseClient };
